import { css } from 'styled-system/css';

export const menuIconStyle = {
	menuIconButton: css({
		base: {
			pos: 'relative',

			'& .new-tag': {
				position: 'absolute',
				top: '2px',
				left: '2px',
				zIndex: 1,
			},
		},
	}),
	menuIcon: css({
		_mars: {
			position: 'relative',
		},
	}),
	menuLiveIcon: css({
		base: {
			display: 'none',
		},
		_mars: {
			position: 'absolute',
			bottom: 0,
			right: 0,
			width: '12px',
			height: '12px',
			bgColor: 'sportsMenu.bg',
			rounded: '6px',
			'& .icon': {
				display: 'block',
				width: '12px',
				height: '12px',
				color: 'status.negative',
				mb: 0,
			}
		},
	}),
	menuIconNew: css({
		base: {
			pos: 'absolute',
		}
	}),
	menuIconText: css({
		_mars: {
			fontWeight: 'normal',
			fontSize: '14px',
		}
	}),
};